import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const pdokApi = createApi({
    reducerPath: 'pdokApi',
    baseQuery: fetchBaseQuery({ baseUrl: 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/' }),
    endpoints: (builder) => ({
        searchCityLocation: builder.query({
            query: (query) => `suggest?q=${query}&rows=100&fq=type:(woonplaats)&fl=id weergavenaam score`,
            transformResponse: (searchResponse) => {
                return searchResponse.response.docs;
            }
        }),
        searchAddressLocation: builder.query({
            query: (query) => `suggest?q=${query}&rows=100&fq=type:(adres OR postcode)&fl=id weergavenaam score`,
            transformResponse: (searchResponse) => {
                return searchResponse.response.docs;
            }
        }),
        searchAllLocation: builder.query({
            query: (query) => `suggest?q=${query}&rows=100&&fl=id weergavenaam score`,
            transformResponse: (searchResponse) => {
                return searchResponse.response.docs;
            }
        }),
        getLocation: builder.query({
            query: (id) => `lookup?id=${id}&fl=id woonplaatsnaam weergavenaam postcode centroide_ll huisnummer straatnaam`,
            transformResponse: (searchResponse) => {
                return searchResponse.response.docs[0];
            }
        })
    })
});
export const { useLazySearchCityLocationQuery, useLazySearchAddressLocationQuery, useLazyGetLocationQuery, useLazySearchAllLocationQuery } = pdokApi;
